/**
 * Dual-writes Algolia search interaction events to GA4 via the existing gtag.
 * Algolia collects these same events through search-insights, but reading them
 * back (click/conversion analytics per query) is gated behind premium plans —
 * so we keep our own copy of the funnel: query → result click → add-to-cart.
 *
 * The params land in full in a GA4 BigQuery export. To slice by them in GA4
 * reports or the Data API, register them once as event-scoped custom
 * dimensions (Admin → Custom definitions): search_term, object_id, query_id,
 * list_position, surface.
 */

type SearchEventParams = {
  object_id?: string | null;
  query_id?: string | null;
  list_position?: number | null;
  search_term?: string | null;
  /** Where the interaction happened: 'search' | 'collection' | 'cart' */
  surface?: string;
  price?: number;
  currency?: string;
  filter_attribute?: string | null;
  filter_value?: string | null;
};

export function trackSearchEvent(eventName: string, params: SearchEventParams): void {
  if (typeof window.gtag !== 'function') return;

  // Drop empty values so GA4 doesn't store "null"/"undefined" strings
  const clean = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== null && v !== undefined && v !== '' && v !== 'undefined' && !Number.isNaN(v),
    ),
  );

  window.gtag('event', eventName, clean);
}

/** The search term the shopper used, from the page URL (?q= on /search) */
export function currentSearchTerm(): string | null {
  return new URLSearchParams(window.location.search).get('q');
}
